import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardNavbar from '../components/layout/DashboardNavbar';

const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-jp-section">
      {/* Navbar */}
      <DashboardNavbar userRole="admin" />

      {/* Page Content */}
      <div className="pt-16 sm:pt-20">
        <Outlet />
      </div>
    </div>
  );
};

export { AdminLayout };
export default AdminLayout;
